<template>
  <nav class="top-nav-wrap">
    <div>
      <b-navbar toggleable="lg" type="light" variant="default" class="header modern-navbar">
        <b-navbar-brand href="#" class="brand-wrap">

          <b-img :src="baseurl + 'img/logo.png'" fluid alt="Fluid image"></b-img>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav right>
            <b-link to="/" class="nav-link"><b-icon icon="house-fill"></b-icon> Home</b-link>
            <div v-for="item in menu" :key="item.roleid">

              <b-link :to="'/' + item.route" class="nav-link"><b-icon :icon="item.icon"></b-icon> {{ item.menunama
                }}</b-link>
            </div>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto align-items-center">
            <div class="user-chip-wrap d-flex align-items-center mr-3" v-if="isLogin && nama">
              <b-avatar size="34px" :variant="levelBadgeVariant" class="mr-2 font-weight-bold text-white shadow-sm">
                {{ userInitials }}
              </b-avatar>
              <div class="user-info-text d-none d-md-block text-left mr-2">
                <div class="user-name font-weight-bold text-dark" style="font-size: 0.88rem; line-height: 1.2;">
                  {{ nama }}
                </div>
                <b-badge :variant="levelBadgeVariant" class="px-2 py-0 font-weight-bold" style="font-size: 0.7rem;">
                  {{ level }}
                </b-badge>
              </div>
            </div>

            <b-button
              size="sm"
              variant="outline-danger"
              class="logout-btn rounded-pill px-3 font-weight-bold d-flex align-items-center shadow-sm"
              @click="confirmLogout"
              v-if="isLogin"
            >
              <b-icon icon="power" class="mr-1"></b-icon>
              <span>Logout</span>
            </b-button>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </nav>
</template>
<script>
import axios from "axios";
export default {
  name: "HeaderMenu",
  data: () => {
    return {
      isLogin: localStorage.getItem("isLogin"),
      nama: "",
      level: "",
      menu: '',
      baseurl: process.env.BASE_URL
    };
  },
  mounted() {
    this.isLogin = localStorage.getItem("isLogin");
    // alert(this.baseurl);
    this.getInfo()
    // alert(token)
    // alert(this.nama)
  },
  computed: {
    levelBadgeVariant() {
      switch (this.level) {
        case "Administrator":
          return "danger";
        case "Admin Prodi":
          return "primary";
        case "Dosen":
          return "info";
        case "Mahasiswa":
          return "success";
        case "Wadir":
          return "dark";
        default:
          return "secondary";
      }
    },
    userInitials() {
      if (!this.nama) return "U";
      const parts = this.nama.trim().split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return this.nama.substring(0, 2).toUpperCase();
    },
  },
  methods: {
    confirmLogout() {
      this.$swal
        .fire({
          title: "Konfirmasi Logout",
          text: "Apakah Anda yakin ingin keluar dari sistem KKP?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Ya, Keluar",
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.logout();
          }
        });
    },
    logout() {
      localStorage.clear();
      window.location.href = window.location.origin + (this.baseurl || "/");
    },
    getInfo: async function () {
      let token = localStorage.getItem("token");
      if (token != null) {
        await axios
          .request({
            headers: {
              Authorization: `Bearer ` + token,
            },
            method: "GET",
            url: `me`,
          })
          .then((response) => {
            this.nama = response.data.info.nama
            this.menu = response.data.info.menu;
            this.level = (response.data.info.level == 1 ? 'Administrator' : (response.data.info.level == 2 ? 'Admin Prodi' : (response.data.info.level == 3 ? "Dosen" : (response.data.info.level == 4 ? "Mahasiswa" : (response.data.info.level == 9 ? "Wadir" : "User")))))
            localStorage.setItem('isLevel', response.data.info.level)
          })
          .catch(function () {
            // handle error
          })
          .finally(function () {
            // always executed
          });
      }

      return false;
    },
  },
};
</script>
<style scoped lang="scss">
.navbar {
  padding: 0;
}

.top-nav-wrap {
  position: sticky;
  top: 0;
  z-index: 1040;
}

.modern-navbar {
  border-bottom: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(147, 197, 253, 0.98);
  backdrop-filter: blur(6px);
  box-shadow: 0 10px 24px rgba(30, 64, 175, 0.24);
  position: relative;
}

.brand-wrap {
  padding-left: 12px;
}

.brand-wrap img {
  max-height: 44px;
  width: auto;
  filter: drop-shadow(0 2px 6px rgba(30, 64, 175, 0.18));
}

ul .nav-link {
  margin: 6px 6px;
  padding: 10px 16px;
  font-size: 11pt;
  font-weight: 500;
  color: #1f2937 !important;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(255, 255, 255, 0.55);
  transition: all 0.25s ease;
}

ul .nav-link:hover {
  color: #0f172a !important;
  border: 1px solid rgba(125, 211, 252, 0.5);
  background: linear-gradient(90deg, rgba(186, 230, 253, 0.6) 0%, rgba(199, 210, 254, 0.55) 100%);
  box-shadow: 0 8px 16px rgba(56, 189, 248, 0.18);
}

.router-link-exact-active {
  color: #ffffff !important;
  border: 1px solid rgba(37, 99, 235, 0.75);
  background: linear-gradient(90deg, rgba(37, 99, 235, 0.96) 0%, rgba(59, 130, 246, 0.92) 100%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14), 0 10px 20px rgba(37, 99, 235, 0.28);
}

ul .nav-item {
  padding: 20px;
  font-size: 14pt;
}

.dropdown-menu li {
  font-size: 14pt;
}

.logout-link {
  color: #b91c1c !important;
}

.logout-link:hover {
  color: #991b1b !important;
  background: linear-gradient(90deg, rgba(254, 202, 202, 0.6) 0%, rgba(254, 205, 211, 0.55) 100%);
}

.logout-nav {
  margin-left: auto;
}

@media (max-width: 991.98px) {
  .modern-navbar :deep(.navbar-collapse) {
    position: absolute;
    top: calc(100% + 6px);
    left: 10px;
    right: 10px;
    z-index: 2000;
    padding: 10px;
    border: 1px solid rgba(148, 163, 184, 0.35);
    border-radius: 14px;
    background: linear-gradient(120deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.97) 100%);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
  }

  .modern-navbar :deep(.navbar-nav) {
    flex-direction: column;
  }

  .modern-navbar :deep(.navbar-nav .nav-link) {
    display: block;
    width: 100%;
    font-size: 10pt;
    padding: 8px 12px;
  }

  .modern-navbar :deep(.navbar-brand img) {
    max-height: 34px;
  }
}

.navbrand {
  padding-top: 0px;
  padding-bottom: 0px;
}

// .navbar-collapse .navbar-nav .nav-link{
//   padding: 10px;
// }
// .navbar-collapse .navbar-nav .router-link-exact-active{
//   background-color: #0d6efd;
//   color: #ccc;
// }</style>
